'use strict';

var debug = require('debug');
/**
 * Creates a logger for the given subsystem
 *
 * @param {PeerId} [id]
 * @param {string} [subsystem]
 * @returns {debug}
 *
 * @private
 */


exports.logger = function (id, subsystem) {
  var name = ['bitswap'];

  if (subsystem) {
    name.push(subsystem);
  }

  if (id) {
    name.push("".concat(id.toB58String().slice(0, 8)));
  }

  var logger = debug(name.join(':'));
  logger.error = debug(name.concat(['error']).join(':'));
  return logger;
};